import React, { useCallback, useEffect, useState } from 'react'

const useContextMenu = (outerRef: React.RefObject<any>) => {
  const [xPos, setXPos] = useState('0px')
  const [yPos, setYPos] = useState('0px')
  const [showMenu, setShowMenu] = useState(false)
  const handleContextMenu = useCallback(
    (event) => {
      if (outerRef?.current?.contains(event.target)) {
        event.preventDefault()
        setXPos(`${event.pageX}px`)
        setYPos(`${event.pageY}px`)
        setShowMenu(true)
      } else {
        setShowMenu(false)
      }
    },
    [outerRef, setXPos, setYPos]
  )

  const handleClick = useCallback(() => {
    setShowMenu(false)
  }, [])

  useEffect(() => {
    document.addEventListener('click', handleClick)
    document.addEventListener('contextmenu', handleContextMenu)
    // cleanup
    return () => {
      document.removeEventListener('click', handleClick)
      document.removeEventListener('contextmenu', handleContextMenu)
    }
  })

  useEffect(() => {
    const elem = document.getElementById('ConversationSidebar')
    if (elem) showMenu ? (elem.style.overflow = 'hidden') : (elem.style.overflow = 'hidden scroll')
  }, [showMenu])

  return { xPos, yPos, showMenu }
}

export default useContextMenu
